if (!customElements.get('ms24-collection-view')) {
  customElements.define('ms24-collection-view', class extends HTMLElement {
    static preference = 'list';

    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      if (this.onViewClick) this.removeEventListener('click', this.onViewClick);
    }

    initialize() {
      if (!this.isConnected) return;
      this.grid = this.querySelector('[data-ms24-product-grid]');
      const template = this.querySelector('template[data-ms24-classic-cards]');
      if (!this.grid || !template) return;
      if (!this.cards) {
        this.cards = {
          list: Array.from(this.grid.children),
          classic: Array.from(template.content.children)
        };
      }
      this.onViewClick = event => {
        const button = event.target.closest('button[data-ms24-view]');
        if (button && this.contains(button)) this.setView(button.dataset.ms24View, true);
      };
      this.addEventListener('click', this.onViewClick);
      let preferred = this.constructor.preference;
      this.setView(preferred);
      this.querySelector('.ms24-view-switch').hidden = false;
    }

    setView(view, remember = false) {
      view = view === 'classic' ? 'classic' : 'list';
      if (this.view !== view) {
        this.grid.classList.toggle('ms24-collection-list', view === 'list');
        if (this.view || view === 'classic') this.grid.replaceChildren(...this.cards[view]);
        this.view = view;
        this.dataset.view = view;
      }
      this.querySelectorAll('button[data-ms24-view]').forEach(button => {
        const active = button.dataset.ms24View === view;
        button.setAttribute('aria-pressed', String(active));
        button.classList.toggle('button--primary', active);
        button.classList.toggle('button--secondary', !active);
      });
      if (remember) {
        this.constructor.preference = view;
      }
    }

    appendPage(parsedHTML) {
      const source = parsedHTML.querySelector('ms24-collection-view');
      const grid = source?.querySelector('[data-ms24-product-grid]');
      const template = source?.querySelector('template[data-ms24-classic-cards]');
      if (!grid || !template) return;
      const incoming = {
        list: Array.from(grid.children),
        classic: Array.from(template.content.children)
      };
      this.cards.list.push(...incoming.list);
      this.cards.classic.push(...incoming.classic);
      this.grid.append(...incoming[this.view]);
    }
  });
}
